import React, { useState } from "react";
import "./MobileNavMenu.css";
import logo from "../../Images/Clariss-Logo.webp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faMagnifyingGlass,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import Cart from "../Cart/Cart";
import { Link } from "react-router-dom";
import PopCart from "../PopCart/PopCart";
import MobileSearch from "../MobileSearch/MobileSearch";
import MobileCategory from "../MobileCategory/MobileCategory";

const MobileNavMenu = ({ popCart, handlePopCart }) => {
  const [userLogin, setUserLogin] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [menu, setMenu] = useState(false);

  const handleUserLogin = () => {
    setUserLogin(!userLogin);
    setShowSearch(false);
  };

  const handleSearch = (search) => {
    setShowSearch(search);
  };

  const handleMenu = (menuState) => {
    setMenu(menuState);
    setShowSearch(false);
    if (menuState) {
      handlePopCart(false);
    }
  };

  // ✅ Prevent body scroll when menu/search/cart active
  if (popCart || userLogin || showSearch || menu) {
    if (window.innerWidth < 640) {
      document.body.style.overflow = "hidden";
    }
  } else {
    document.body.style.overflow = "visible";
  }

  return (
    <nav
      className={`mobile-menu-container ${
        showSearch ? "searched-nav-menu" : ""
      }`}
      aria-label="Mobile Navigation Menu"
    >
      {/* ✅ Cart Popup */}
      <PopCart handlePopCart={handlePopCart} popCart={popCart} />

      <div className="flex">
        {/* ✅ Hamburger Menu */}
        <button
          className="text-secondary mr-8 text-xl"
          aria-label="Open Menu"
          onClick={() => handleMenu(true)}
        >
          <FontAwesomeIcon icon={faBars} />
        </button>
        <MobileCategory menu={menu} handleMenu={handleMenu} />

        {/* ✅ Search Button */}
        <button
          aria-label="Search Products"
          onClick={() => handleSearch(!showSearch)}
          className="text-secondary text-xl"
        >
          <FontAwesomeIcon icon={faMagnifyingGlass} />
        </button>
        <MobileSearch showSearch={showSearch} handleSearch={handleSearch} />
      </div>

      {/* ✅ Logo linking to homepage */}
      <Link to="/" aria-label="Clariss Bangladesh Homepage">
        <img
          className="w-[60%] mx-auto px-4"
          src={logo}
          alt="Clariss Bangladesh - Natural & Organic Skincare"
          width={200}
          height={80}
        />
      </Link>

      {/* ✅ User Profile / Dashboard */}
      <Link
        className="ml-auto"
        to="/customerDashboard"
        aria-label="Customer Dashboard"
      >
        <FontAwesomeIcon
          className="text-secondary text-2xl absolute right-16 bottom-[26px]"
          icon={faUser}
        />
      </Link>

      {/* ✅ Mobile Cart */}
      <div className="ml-auto">
        <Cart
          popCart={popCart}
          handlePopCart={handlePopCart}
          handleSearch={handleSearch}
        />
      </div>

      {/* ✅ Overlay for menu/search */}
      <span
        className={`overlay ${
          showSearch ? "searched-overlay" : "not-searched-overlay"
        } ${userLogin ? "overlay-active" : ""} ${
          popCart || menu ? "overlay-active " : ""
        }`}
        aria-hidden={!(showSearch || popCart || menu)}
      ></span>
    </nav>
  );
};

export default MobileNavMenu;
